import { UserSettings } from "@/config";
import { NicknameRegex } from "@/services/validators";
import { z } from "zod";
import { UserId_Schema } from "@/services/user/userIdSchema";
import { CategoryId_Schema } from "@/services/collection/categories/categoriesSchema";
import { DateTimeIso8601Local_Schema, WholeNumber_Schema } from "@/utilities/schema";

export const Nickname_Schema = z.string().min(UserSettings.nicknameMinLength).max(UserSettings.nicknameMaxLength).regex(NicknameRegex);

export const UserProfile_Schema = z
  .object({
    id: UserId_Schema,
    filterCategories: z
      .object({
        id: CategoryId_Schema,
        name: z.string(),
        count: WholeNumber_Schema,
      })
      .array(),
    publicProfilePhotoUrl: z.string().nullable(),
    nickname: Nickname_Schema,
    publicFullName: z.string(),
    publicEmail: z.string(),
    publicPhone: z.string(),
    publicUrlFacebook: z.string(),
    publicUrlInstagram: z.string(),
    publicUrlTikTok: z.string(),
    publicUrlPinterest: z.string(),
    publicUrlWeb: z.string(),
    publicBioDescription: z.string(),
    isChatEmailNotificationEnabled: z.boolean().optional(),
    holidayUntil: DateTimeIso8601Local_Schema.nullable(),

    // There is more, we do not use it, feel free to add it.
  })
  .meta({
    openapi: "PublicCollectorResponse",
  })
  .transform(({ holidayUntil, isChatEmailNotificationEnabled, ...rest }) => ({
    ...rest,
    absenceUntil: holidayUntil ?? null,
    isChatEmailNotificationEnabled: isChatEmailNotificationEnabled ?? false, // we want boolean
  }));
